
import { useQuery } from "@tanstack/react-query";
import { getServicesTransactions } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

/**
 * Hook مسؤول عن جلب معاملات الخدمات مع إدارة الكاش والأخطاء
 * - يأخذ queryParams كـ object
 * - يعيد: transactions, total, loading, error, next, previous, refetch
 */
export const useServicesTransactions = (queryParams) => {
  const queryKey = ["servicesTransactions", queryParams];

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        return await getServicesTransactions(queryParams);
      } catch (err) {
        throw new Error(handleApiError(err));
      }
    },
    keepPreviousData: true, 
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 12, 
    refetchOnWindowFocus: false,
  });

  return {
    transactions: data?.transactions ?? [],
    total: data?.total ?? 0,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
  };
};






















































